"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FakeChatClient = void 0;
class FakeChatClient {
    constructor() {
        this.conversations = {};
    }
    addConversation(question, result) {
        this.conversations[question] = result;
    }
    doChat(request, _abortSignal) {
        const entry = request.chatHistory[request.chatHistory.length - 1];
        const result = this.conversations[entry.content];
        if (!result) {
            return Promise.reject('result not set');
        }
        if (result instanceof String) {
            return Promise.reject(result);
        }
        return Promise.resolve(result);
    }
    sendClipFeedback(request, _abortSignal) {
        if (request.selectedOptionId === '-1') {
            return Promise.reject();
        }
        return Promise.resolve();
    }
    sendMessageFeedback(request, _abortSignal) {
        if (!request.thumbsUp) {
            return Promise.reject();
        }
        return Promise.resolve();
    }
    getClipFeedbackOptions() {
        return Promise.resolve({
            positive: {
                100: 'Great!',
                101: 'Solid',
            },
            negative: {
                200: "I'm going to sue",
                201: 'A load of tosh',
            },
        });
    }
    clear() {
        this.conversations = {};
    }
}
exports.FakeChatClient = FakeChatClient;
//# sourceMappingURL=FakeChatClient.js.map